import styled from 'styled-components';

export const Stock = styled.span<{ isCopyable?: boolean }>`
  background-color: transparent;
  color: currentColor;
  line-height: 1.4;
  cursor: ${({ isCopyable }) => (isCopyable ? 'pointer' : 'default')};
`;
